/* eslint-disable */
import React, { Component } from 'react';
import styled from 'styled-components';
import TextContent from './TextContent';
import ImageContent from './ImageContent';

const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;

  /* border: 1px dashed red; */
`;

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vh: 0,
      slideNumber: 0
    };
    this.pageSplitTimes = 1.4;
    this.lastScrollTop = 0;
    this.scrollDirectionDown = true;
    this.handleScroll = this.handleScroll.bind(this);
    this.workDetails = [
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: ['']
      },
      {
        number: '01',
        projectName: 'ThinkUp',
        projectDesc: [
          'SaaS application that accelerates the growth of startups.',
          'I learned so much about design while building site features and especially while building the main matrix.'
        ],
        projectType: 'WEB APP',
        roles: ['• Front-end Developer']
      },
      {
        number: '02',
        projectName: 'RedStation',
        projectDesc: [
          'Confidential military system that configures a variety of communication equipment.',
          'Creating healthy communication among all those involved in the project.'
        ],
        projectType: 'WEB APP',
        roles: ['• Technical PM & Developer']
      },
      {
        number: '03',
        projectName: 'Dashboard',
        projectDesc: [
          'Versatile admin dashboard that makes the store management experience very convenient.',
          'The images are waiting to be hovered over',
          'The images are waiting to be clicked on'
        ],
        projectType: 'WEB APP',
        roles: ['• Technical PM & Developer']
      },
      {
        number: '04',
        projectName: 'My Content',
        projectDesc: [
          'Presenting content on web development to enrich the team.',
          'Writing project building processes and documentation summaries on new technologies.'
        ],
        projectType: 'ARTICLES & PRESENTATIONS',
        roles: ['• Writer']
      },

      //   {
      //     number: '05',
      //     projectName: 'ComingOrNot',
      //     projectDesc:
      //       'Event planner web app that strives to ease the work of an organizer, conduct events in a less chaotic way.',
      //     projectType: 'WEB APP',
      //     roles: ['• Front-end Developer', 'UI Designer']
      //   },
      //   {
      //     number: '06',
      //     projectName: 'Tesla app',
      //     projectDesc: 'iOS app concept to control Tesla cars remotely.',
      //     projectType: 'iOS APP CONCEPT',
      //     roles: ['UI Designer']
      //   },

      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: ['']
      }
    ];
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState({
      vh: Math.round(window.document.documentElement.clientHeight * this.pageSplitTimes)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const { vh, slideNumber } = this.state;
    const scrollDistance = Math.max(body.scrollTop, documentElement.scrollTop);
    if (scrollDistance > this.lastScrollTop) {
      this.scrollDirectionDown = true;
    } else {
      this.scrollDirectionDown = false;
    }
    this.lastScrollTop = scrollDistance;
    // console.log(scrollDistance);

    if (Math.floor(scrollDistance / vh) !== slideNumber && slideNumber < this.workDetails.length - 1) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    } else if (slideNumber === this.workDetails.length - 1 && Math.floor(scrollDistance / vh) < slideNumber) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    }
  }

  changeTextContentBasedOnScroll() {
    const { slideNumber } = this.state;
    const refresh = true;
    return (
      <TextContent
        number={this.workDetails[slideNumber].number}
        projectName={this.workDetails[slideNumber].projectName}
        projectDesc={this.workDetails[slideNumber].projectDesc}
        projectType={this.workDetails[slideNumber].projectType}
        roles={this.workDetails[slideNumber].roles}
        refreshToggle={refresh}
      />
    );
  }

  render() {
    return (
      <Container>
        {this.changeTextContentBasedOnScroll()}
        <ImageContent pageSplitTimes={this.pageSplitTimes} />
      </Container>
    );
  }
}

export default Work;
